// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JmQHe","comment":"styles_comment__2WM58"};